;(function () {
	'use strict';
  let runVideo = false;
  function playOnScroll(e) {
    let video = document.getElementById("featured-video_home");
    
    if (!video) return;
    
    let videoContainerParams = video.getBoundingClientRect()
    let videoOffsetTop = videoContainerParams.top
    let videoHeight = videoContainerParams.height
      
    let documentParams = document.body.getBoundingClientRect()
    let documentHeight = documentParams.height
    
    let player = new Vimeo.Player(video);
    console.log('player', player);
      
    if(video && !runVideo) {
      
      if((videoOffsetTop < documentHeight * 0.5 ) && videoOffsetTop > 0) {
        player.play();
        if(!runVideo) {
          runVideo = true;
        }
      }
    }
    if((videoOffsetTop + videoHeight) < (documentHeight * -0.75 )) {
      player.pause();
    }
  }
  
  window.addEventListener('scroll', playOnScroll);
  
}());


$(function(){
  // scroll to links
  $(document).on('click', '[href^="#"]', function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    if (aid != '#') {
      $('html,body').animate({scrollTop: $(aid).offset().top - 60},'slow');
    }
  });
  
  // open reviews tab
  $(document).on('click', '[href="#shopify-product-reviews"]', function(e) {
    $('.product-tab--reviews .product-tab-title').click();
  });
  
  // Cart page
  $(document).on('click', '#CartPopoverCont', function(){
    location.href = '/cart';
  });
});